import get from 'lodash/get'
import {
  FETCH_POLLS_REQUEST,
  FETCH_POLLS_SUCCESS,
  FETCH_POLLS_FAIL,
  SAVE_POLL_REQUEST,
  SAVE_POLL_SUCCESS,
  SAVE_POLL_FAIL,
  CHANGE_ANSWER,
  ADD_ANSWER_GROUP,
  DELETE_ANSWER_GROUP,
  MARK_CORRECT_ANSWER_GROUP,
  CHANGE_POLL_TYPE,
  DELETE_POLL_SUCCESS,
  PUBLISH_POLL,
  UNPUBLISH_POLL,
  LOAD_POLL,
  SORT_POLL_TYPE_CHANGE,
  CLEAR_POLL_STATE,
  SEARCH_POLL,
  CLEAR_SEARCH,
  CHANGE_POLL_PAGE,
  DISABLE_POLL_TYPE_CHANGE,
  FILTER_POLL_CHANGE,
} from 'actions/Polls/types'

export const defaultState = {
  polls: [],
  filteredPolls: [],
  pollFilter: 'all',
  disablePollType: false,
  sortType: 'updated',
  answerGroups: [
    {
      answer: '',
      result: '',
      count: 0,
      isCorrect: false,
    },
  ],
  pollType: 'correct_answer',
  currentPoll: null,
  isLoading: false,
  isSearching: false,
  currentPage: 1,
}

export default (state = defaultState, action) => {
  switch (action.type) {
    case DISABLE_POLL_TYPE_CHANGE:
      return {
        ...state,
        disablePollType: true,
      }
    case CLEAR_SEARCH:
      return {
        ...state,
        isSearching: false,
        filteredPolls: [],
      }
    case CLEAR_POLL_STATE:
      return {
        ...defaultState,
        currentPage: state.currentPage,
      }
    case CHANGE_POLL_TYPE:
      return {
        ...state,
        pollType: action.pollType,
        answerGroups: defaultState.answerGroups,
      }
    case FETCH_POLLS_REQUEST:
      return {
        ...state,
        isLoading: true,
      }
    case FETCH_POLLS_SUCCESS:
      return {
        ...state,
        polls: sortPolls(action.polls, state.sortType),
        isLoading: false,
      }
    case FETCH_POLLS_FAIL:
      return {
        ...state,
        isLoading: false,
      }
    case SAVE_POLL_REQUEST:
      return {
        ...state,
        isLoading: true,
      }
    case SAVE_POLL_SUCCESS:
      return {
        ...state,
        isLoading: false,
      }
    case SAVE_POLL_FAIL:
      return {
        ...state,
        isLoading: false,
      }
    case CHANGE_ANSWER:
      const indexToChange = action.name.slice(-1) - 1
      const fieldToChange = action.name.slice(0, -1)

      const changedGroup = {
        ...state.answerGroups[indexToChange],
        [fieldToChange]: action.text,
      }

      return {
        ...state,
        answerGroups: [
          ...state.answerGroups.slice(0, indexToChange),
          changedGroup,
          ...state.answerGroups.slice(indexToChange + 1),
        ],
        disablePollType: true,
      }
    case ADD_ANSWER_GROUP:
      let numAnswerGroups = state.answerGroups.length
      if (numAnswerGroups === 6) {
        return state
      }

      return {
        ...state,
        answerGroups: state.answerGroups.concat({
          answer: '',
          result: '',
          isCorrect: false,
        }),
        disablePollType: true,
      }
    case DELETE_ANSWER_GROUP:
      numAnswerGroups = state.answerGroups.length
      if (numAnswerGroups <= 1) {
        return state
      }

      return {
        ...state,
        answerGroups: [
          ...state.answerGroups.slice(0, action.indexToDelete),
          ...state.answerGroups.slice(action.indexToDelete + 1),
        ],
      }
    case MARK_CORRECT_ANSWER_GROUP:
      const correctIndex = action.groupNumber - 1
      const answerGroups = state.answerGroups.slice().map((group, i) => {
        if (correctIndex === i) {
          return {
            ...group,
            isCorrect: true,
          }
        } else {
          return {
            ...group,
            isCorrect: false,
          }
        }
      })

      return {
        ...state,
        answerGroups,
        disablePollType: true,
      }
    case DELETE_POLL_SUCCESS:
      const pollToDeleteIndex = state.polls.findIndex(
        poll => action.pollId === poll.id,
      )
      const filteredPollToDeleteIndex = state.filteredPolls.findIndex(
        poll => action.pollId === poll.id,
      )

      return {
        ...state,
        polls: [
          ...state.polls.slice(0, pollToDeleteIndex),
          ...state.polls.slice(pollToDeleteIndex + 1),
        ],
        filteredPolls: [
          ...state.polls.slice(0, filteredPollToDeleteIndex),
          ...state.polls.slice(filteredPollToDeleteIndex + 1),
        ],
      }
    case PUBLISH_POLL:
      const indexToPublish = state.polls.findIndex(
        poll => poll.id === action.pollId,
      )

      const publishedPoll = {
        ...state.polls[indexToPublish],
        active: true,
      }

      return {
        ...state,
        polls: [
          ...state.polls.slice(0, indexToPublish),
          publishedPoll,
          ...state.polls.slice(indexToPublish + 1),
        ],
      }
    case UNPUBLISH_POLL:
      const indexToUnpublish = state.polls.findIndex(
        poll => poll.id === action.pollId,
      )

      const unpublishedPost = {
        ...state.polls[indexToUnpublish],
        active: false,
      }

      return {
        ...state,
        polls: [
          ...state.polls.slice(0, indexToUnpublish),
          unpublishedPost,
          ...state.polls.slice(indexToUnpublish + 1),
        ],
      }
    case LOAD_POLL:
      const { poll } = action
      const pollType = getPollType(poll, poll.answers)
      let isCorrect = -1

      isCorrect = poll.answers.findIndex(g => g.isCorrect) + 1

      const tags = get(poll, 'tags', []).map(tag => ({
        label: `${tag.name} - ${tag.category}`,
        value: tag.id,
      }))

      return {
        ...state,
        pollType,
        disablePollType: true,
        answerGroups: poll.answers.sort((a, b) => a.index - b.index),
        currentPoll: {
          ...poll,
          tags,
          isCorrect,
        },
      }
    case SORT_POLL_TYPE_CHANGE:
      return {
        ...state,
        polls: sortPolls(state.polls, action.sortType),
        sortType: action.sortType,
      }
    case SEARCH_POLL:
      const { searchString } = action
      const isSearching = searchString !== ''

      const filteredPolls = filterByQuestion(state.polls, searchString)

      return {
        ...state,
        filteredPolls,
        isSearching,
      }
    case CHANGE_POLL_PAGE:
      return {
        ...state,
        currentPage: action.page,
      }
    case FILTER_POLL_CHANGE:
      return {
        ...state,
        pollFilter: action.pollFilter,
        currentPage: 1,
      }
    default:
      return state
  }
}
function getPollType(poll, answerGroups) {
  if (answerGroups.length === 1) {
    return 'survey'
  }

  if (answerGroups.every(group => group.isCorrect === false)) {
    return poll.multiple ? 'multiple_answer' : 'poll'
  }

  return 'correct_answer'
}

function sortPolls(polls, sortType) {
  switch (sortType) {
    case 'updated':
      return polls.sort((a, b) => b.updated - a.updated)
    case 'updated-ascending':
      return polls.sort((a, b) => a.updated - b.updated)
    case 'created':
      return polls.sort((a, b) => b.created - a.created)
    case 'created-ascending':
      return polls.sort((a, b) => a.created - b.created)
    case 'published':
      return polls.sort(
        (a, b) => (a.active === b.active ? 0 : a.active ? -1 : 1),
      )
    case 'unpublished':
      return polls.sort(
        (a, b) => (a.active === b.active ? 0 : a.active ? 1 : -1),
      )
    default:
      return polls
  }
}

function filterByQuestion(polls, searchString) {
  const searchTerms = searchString.toLowerCase()
  return polls.filter(poll => {
    return poll.question.toLowerCase().search(searchTerms) !== -1
  })
}
